import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";

const Documentacion = () => {
  const navigate = useNavigate();

  const [formaJuridica, setFormaJuridica] = useState("");
  const [descripcionServicio, setDescripcionServicio] = useState("");
  const [alcanceServicio, setAlcanceServicio] = useState("");
  const [erroresCampos, setErroresCampos] = useState({});
  const [envioExitoso, setEnvioExitoso] = useState(false); 
  const [enviando, setEnviando] = useState(false); 
  const [cantidadTrabajadores, setCantidadTrabajadores] = useState("");
  const [cantidadVehiculos, setCantidadVehiculos] = useState("");
  const [cantidadEquipos, setCantidadEquipos] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [erroresDinamicos, setErroresDinamicos] = useState({});
  const [habilitadoSiguiente, setHabilitadoSiguiente] = useState(false);
  const [formTouched, setFormTouched] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);  

  // 👉 Renderiza inputs (select o texto)
  const renderInput = (campo, nombre, index) => {
    const camposSelect = [
      "Conduce vehículo en sitio",
      "Conduce transporte de pasajeros",
      "Opera equipo especial"
    ];

    if (camposSelect.includes(campo)) {
      return (
        <select name={`${nombre}_${campo}_${index}`} className={`input-field ${erroresDinamicos[`${nombre}_${campo}_${index}`] ? "error" : ""}`} defaultValue="">
          <option value="">Seleccionar</option>
          <option value="SI">SI</option>
          <option value="NO">NO</option>
        </select>
      );
    }

    return (
      <input type="text" name={`${nombre}_${campo}_${index}`} className={`input-field ${erroresDinamicos[`${nombre}_${campo}_${index}`] ? "error" : ""}`} />
    );
  };

  const renderTableFilas = (cantidad, campos, nombre, label) => (
    <div style={{ marginTop: "20px" }}>
      <label style={{ fontWeight: "bold", display: "block", marginBottom: "5px" }}>{label}</label>
      <table className="compact-table">
        <thead>
          <tr>
            {campos.map((campo, idx) => <th key={idx}>{campo}</th>)}
          </tr>
        </thead>
        <tbody>
          {[...Array(Number(cantidad)).keys()].map((_, index) => (
            <tr key={index}>
              {campos.map((campo, idx) => (
                <td key={idx}>{renderInput(campo, nombre, index)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  // 🔄 Recolecta los datos de inputs dinámicos
  const recolectarDatosRecursos = (cantidad, tipo, campos) => {
    const rows = [];
    const erroresLocales = {};
  
    for (let i = 0; i < cantidad; i++) {
      const fila = {};
      campos.forEach((campo) => {
        const name = `${tipo}_${campo}_${i}`;
        const input = document.querySelector(`[name="${name}"]`);
        const valor = input ? input.value.trim() : "";
  
        fila[campo] = valor;
  
        // Guardar error si está vacío
        if (!valor) {
          erroresLocales[name] = true;
        }
      });
      rows.push(fila);
    }
  
    return { rows, erroresLocales };
  };
  
  const handleEnviar = async () => {
    const nuevosErrores = {};

    // Validar campos obligatorios principales
    if (!formaJuridica.trim()) {
      nuevosErrores.formaJuridica = true;
    }
    if (!descripcionServicio.trim()) {
      nuevosErrores.descripcionServicio = true;
    }
    if (!alcanceServicio.trim()) {
      nuevosErrores.alcanceServicio = true;
    }
  
    if (alcanceServicio === "Recurso Ingresa a Sitio") {
      if (!cantidadTrabajadores || cantidadTrabajadores <= 0) {
        nuevosErrores.cantidadTrabajadores = true;
      }
    
      // Solo marcar error si el valor es negativo (pero no si es vacío o 0)
      if (cantidadVehiculos < 0) nuevosErrores.cantidadVehiculos = true;
      if (cantidadEquipos < 0) nuevosErrores.cantidadEquipos = true;
    }
  
    setErroresCampos(nuevosErrores);
  
    if (Object.keys(nuevosErrores).length > 0) {
      alert("Por favor completá todos los campos obligatorios.");
      return;
    }
  
    // Continua con envío si todo está bien
    const idRegistro = localStorage.getItem("idRegistro");
    if (!idRegistro) {
      alert("❌ No se encontró el ID de registro.");
      return;
    }
  
    const { rows: trabajadores, erroresLocales: erroresTrab } = recolectarDatosRecursos(
        cantidadTrabajadores,
        "trabajador",
        ["Nombre", "Apellido", "DNI", "Fecha Nacimiento", "Nacionalidad", "Conduce vehículo en sitio", "Conduce transporte de pasajeros", "Opera equipo especial", "Relación Laboral"]
      );
    
      const { rows: vehiculos, erroresLocales: erroresVeh } = recolectarDatosRecursos(
        cantidadVehiculos,
        "vehiculo",
        ["Dominio / Patente", "Descripción", "Marca", "Modelo", "N° Chasis/Serie", "Tipo Vehículo"]
      );
    
      const { rows: equipos, erroresLocales: erroresEq } = recolectarDatosRecursos(
        cantidadEquipos,
        "equipo",
        ["Dominio / Patente", "Descripción", "Marca", "Modelo", "N° Chasis/Serie", "Tipo Vehículo"]
      );
    
      const erroresCombinados = {
        ...nuevosErrores,
        ...erroresTrab,
        ...erroresVeh,
        ...erroresEq,
      };
    
      setErroresCampos(nuevosErrores);
      setErroresDinamicos(erroresCombinados);
    
      if (Object.keys(erroresCombinados).length > 0) {
        alert("Por favor completá todos los campos obligatorios.");
        return;
      }

      // Guardar en localStorage los recursos para el siguiente paso
      localStorage.setItem("recursosTrabajadores", JSON.stringify(trabajadores));
      localStorage.setItem("recursosVehiculos", JSON.stringify(vehiculos));
      localStorage.setItem("recursosEquipos", JSON.stringify(equipos));

    try {
      setEnviando(true); // ⬅️ arranca envío
      const response = await fetch("/api/guardarRecursos", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idRegistro,
          trabajadores,
          vehiculos,
          equipos,
          formaJuridica,
          descripcionServicio,
          alcanceServicio,
        }),
      });
  
      const data = await response.json();
      if (data.message) {
        setShowModal(true);
        setEnvioExitoso(true);
        setEnviando(false);
        setHabilitadoSiguiente(true);
      } else {
        alert("Error inesperado.");
      }
      
    } catch (err) {
      console.error("❌ Error:", err);
      alert("Error al guardar los recursos.");
      setEnviando(false);
    }
  };

  const confirmBack = () => {
    setShowBackModal(false);
    navigate("/gestionproveedoreshome");
  };
  
  return (
    <div className="cuenta-corriente-container">
      <h2>Documentación</h2>

      <div className="form-row">
        <label>
          Forma Jurídica:
          <select className={`input-field ${erroresCampos.formaJuridica ? "error" : ""}`} value={formaJuridica} onChange={(e) => {setFormaJuridica(e.target.value); setFormTouched(true);}}>
            <option value="">Seleccionar</option>
            <option>Autónomo / Monotributista Empleador</option>
            <option>Mercantil (SRL, SA)</option>
            <option>Monotributista (Unipersonal)</option>
          </select>
        </label>

        <label>
          Descripción del Servicio:
          <select className={`input-field ${erroresCampos.descripcionServicio ? "error" : ""}`} value={descripcionServicio} onChange={(e) => {setDescripcionServicio(e.target.value); setFormTouched(true);}}>
            <option value="">Seleccionar</option>
            <option>Mensual Continuo</option>
            <option>A Tiempo Determinado</option>
            <option>Eventual / Única Vez</option>
          </select>
        </label>

        <label>
          Alcance del Servicio:
          <select className={`input-field ${erroresCampos.alcanceServicio ? "error" : ""}`} value={alcanceServicio} onChange={(e) => {setAlcanceServicio(e.target.value); setFormTouched(true);}}>
            <option value="">Seleccionar</option>
            <option>Recurso Ingresa a Sitio</option>
            <option>Recurso no Ingresa a Sitio</option>
          </select>
        </label>
      </div>

      {alcanceServicio === "Recurso Ingresa a Sitio" && (
        <>
          <div className="form-row">
            <div className="input-column">
              <label>Cantidad de Trabajadores</label>
              <input
                type="number"
                className={`input-field ${erroresCampos.cantidadTrabajadores ? "error" : ""}`}
                placeholder="Ingrese cantidad"
                onChange={(e) => {setCantidadTrabajadores(e.target.value); setFormTouched(true);}}
              />
            </div>

            <div className="input-column">
              <label>Cantidad de Vehículos</label>
              <input
                type="number"
                className={`input-field ${erroresCampos.cantidadVehiculos ? "error" : ""}`}
                placeholder="Ingrese cantidad"
                onChange={(e) => {setCantidadVehiculos(e.target.value); setFormTouched(true);}}
              />
            </div>

            <div className="input-column">
              <label>Cantidad de Equipos</label>
              <input
                type="number"
                className={`input-field ${erroresCampos.cantidadEquipos ? "error" : ""}`}
                placeholder="Ingrese cantidad"
                onChange={(e) => {setCantidadEquipos(e.target.value); setFormTouched(true);}}
              />
            </div>
          </div>

          {cantidadTrabajadores > 0 &&
            renderTableFilas(
              cantidadTrabajadores,
              ["Nombre", "Apellido", "DNI", "Fecha Nacimiento", "Nacionalidad", "Conduce vehículo en sitio", "Conduce transporte de pasajeros", "Opera equipo especial", "Relación Laboral"],
              "trabajador",
              "Trabajadores"
            )}

          {cantidadVehiculos > 0 &&
            renderTableFilas(
              cantidadVehiculos,
              ["Dominio / Patente", "Descripción", "Marca", "Modelo", "N° Chasis/Serie", "Tipo Vehículo"],
              "vehiculo",
              "Vehículos"
            )}

          {cantidadEquipos > 0 &&
            renderTableFilas(
              cantidadEquipos,
              ["Dominio / Patente", "Descripción", "Marca", "Modelo", "N° Chasis/Serie", "Tipo Vehículo"],
              "equipo",
              "Equipos"
            )}
        </>
      )}

        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content animated-popup">
              <div className="check-icon">✔️</div>
              <p>Registros guardados exitosamente</p>
              <div className="modal-buttons">
                <button className="yes-btn" onClick={() => {setShowModal(false);}}>Aceptar</button>
              </div>
            </div>
        </div>
        )}

        {showBackModal && (
        <div className="modal-overlay">
            <div className="modal-content animated-popup">
              <div className="warning-icon">⚠️</div>
              <p>¿Deseás volver? Se perderán los datos ingresados.</p>
              <div className="modal-buttons">
                <button className="yes-btn" onClick={confirmBack}>Sí, volver</button>
                <button className="no-btn" onClick={() => setShowBackModal(false)}>Cancelar</button>
              </div>
            </div>
        </div>
        )}

      {/* Footer con los botones */}
      <div className="button-container">
      <button
        className="secondary-button"
        onClick={() => {
            if (formTouched) setShowBackModal(true);
            else navigate("/gestionproveedoreshome");
        }}
        >
        Volver
        </button>
        <button
            className="secondary-button"
            disabled={!habilitadoSiguiente}
            style={{
                backgroundColor: !habilitadoSiguiente ? "#d3d3d3" : "", // gris claro si está deshabilitado
                color: !habilitadoSiguiente ? "#888" : "",
                cursor: !habilitadoSiguiente ? "not-allowed" : "pointer"
            }}
            onClick={() => navigate("/documentacioncarga")}
            >
            Siguiente
            </button>
        <button className="primary-button" onClick={handleEnviar} disabled={enviando || envioExitoso}>
        {enviando ? "Enviando..." : envioExitoso ? "Enviado" : "Enviar"}
        </button>
      </div>
    </div>
  );
};

export default Documentacion;


